<div class="container bg-header modal-feedback-report-header">
  <div class="row align-items-center">
    <div class="col d-flex align-items-center">
      <h1 mat-dialog-title class="text-white m-0">
        {{ 'modals.feedback-report.title' | translate }}
      </h1>
    </div>
    <div class="col-auto d-flex align-items-center">
      <button
        mat-icon-button
        class="close-toolbar-btn"
        (click)="close()"
        [disabled]="isSubmitting()"
        [matTooltip]="'generic.buttons.close' | translate"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>

<div mat-dialog-content>
  <mat-form-field appearance="outline" class="full-width pb-0">
    <mat-label>{{ 'modals.feedback-report.comment-label' | translate }}</mat-label>
    <textarea
      matInput
      [(ngModel)]="commento"
      [placeholder]="'modals.feedback-report.comment-placeholder' | translate"
      rows="5"
      [disabled]="isSubmitting()"
    ></textarea>
  </mat-form-field>

  <div class="screenshot-option">
    <mat-checkbox
      [(ngModel)]="includeScreenshot"
      [disabled]="isSubmitting()"
    >
      {{ 'modals.feedback-report.include-screenshot' | translate }}
    </mat-checkbox>
  </div>
</div>

<div mat-dialog-actions align="center">
  <button mat-stroked-button class="text-dark-purple border-purple mr-2" (click)="close()" [disabled]="isSubmitting()">
    {{ 'generic.buttons.cancel-and-back' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="submit()"
    [disabled]="isSubmitting()"
  >
    @if (isSubmitting()) {
      <mat-spinner diameter="20"></mat-spinner>
      <span class="ms-2">{{ 'modals.feedback-report.sending' | translate }}</span>
    } @else {
      {{ 'modals.feedback-report.send' | translate }}
    }
  </button>
</div>
